import React from 'react';

import DateField from 'screens/common/sidepanel/DetailSection/DateField';
import styled from 'styled-components';

export function GoalRelativeDueDate({ goalId, goalKey, dispatch, dueDate, detailedStatus, ...props }) {
  return <StyledDateField.RelativeDateDisplay variant="caption" color="textSecondary" date={dueDate} />;
}

const StyledDateField = styled(DateField)`
  border: 1px solid transparent;
  color: ${(props) => props.theme.palette.text.secondary};
  &:hover {
    border-color: ${(props) => props.theme.palette.text.secondary};
  }
  margin-left: -0.5rem;
`;
